<template>
  <div class="topBar">
    <div class="topBar_left">
      <div class="openMenus">
        <el-button
          :icon="Expand"
          size="default"
          circle
          class="collapse-btn"
          @click="this.isCollapse = !this.isCollapse"
        />
      </div>
      <div class="admin-brand">
        <span class="system-title">系统管理中心</span>
        <span class="admin-badge">ADMIN</span>
      </div>
    </div>
  </div>
  <div class="panel">
    <div class="panel_left">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        :collapse="isCollapse"
        @open="handleOpen"
        @close="handleClose"
      >
        <router-link :to="'/admin/aabb/audit'" v-if="status == 2 || status == 1"
          ><el-menu-item index="1">
            <el-icon><setting /></el-icon>
            <template #title>审核管理</template>
          </el-menu-item></router-link
        >
        <router-link :to="'/admin/aabb/personnel'" v-if="status == 1"
          ><el-menu-item index="2">
            <el-icon><document /></el-icon>
            <template #title> 人员管理 </template>
          </el-menu-item></router-link
        >
        <router-link :to="'/admin/aabb/apply'" v-if="status == 2 || status == 1"
          ><el-menu-item index="3">
            <el-icon><SwitchFilled /></el-icon>
            <template #title> 创作管理 </template>
          </el-menu-item></router-link
        >
        <router-link
          :to="'/admin/aabb/feedback'"
          v-if="status == 2 || status == 1"
          ><el-menu-item index="4">
            <el-icon><Warning /></el-icon>
            <template #title> 反馈管理 </template>
          </el-menu-item></router-link
        >
        <router-link
          :to="'/admin/aabb/advertise'"
          v-if="status == 2 || status == 1"
          ><el-menu-item index="5">
            <el-icon><Money /></el-icon>
            <template #title> 广告管理 </template>
          </el-menu-item></router-link
        >

        <router-link :to="'/admin/aabb/ticket'" v-if="status == 1"
          ><el-menu-item index="6">
            <el-icon><Money /></el-icon>
            <template #title> 优惠卷管理 </template>
          </el-menu-item></router-link
        >
        <router-link :to="'/admin/aabb/notice'" v-if="status == 1"
          ><el-menu-item index="7">
            <el-icon><ChatDotSquare /></el-icon>
            <template #title> 通知管理 </template>
          </el-menu-item></router-link
        >
      </el-menu>
    </div>
    <div class="panel_right">
      <el-scrollbar>
        <router-view class="rv" />
      </el-scrollbar>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
} from "vue";
import {
  Document,
  Menu as IconMenu,
  Location,
  Setting,
  Check,
  SwitchFilled,
  Expand,
  Warning,
  Money,
  ChatDotSquare,
} from "@element-plus/icons-vue";

export default defineComponent({
  name: "App",
  data(): any {
    return {
      isCollapse: false,
    };
  },
  components: {
    ChatDotSquare,
    Money,
    Warning,
    Document,
    Setting,
    SwitchFilled,
  },
  computed: {
    Expand() {
      return Expand;
    },
    Check() {
      return Check;
    },
    status(): number {
      return this.$store.state.user.status;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    handleOpen: (key: string, keyPath: string[]) => {},
    handleClose: (key: string, keyPath: string[]) => {},
  },
});
</script>

<style lang="less" scoped>
// 现代化专业管理端规范（深曜冷蓝 + 极简微光）
@topbar-height: 62px;
@admin-navy-bg: #151d2f; // 柔和深绀蓝背景（告别死黑，透气且专业）
@admin-navy-surface: #1c263d; // 侧栏悬停浅层
@admin-active-bg: rgba(99, 102, 241, 0.15); // 选中项水滴半透明浅底
@admin-primary: #6366f1; // 核心科技靛蓝
@admin-text: #94a3b8; // 未选中灰蓝字
@admin-text-active: #ffffff; // 激活纯白
@border-subtle: rgba(255, 255, 255, 0.07); // 侧边栏微光分割线
@topbar-border: #e2e8f0;
@bg-page: #f8fafc;

// 解决 router-link 自带属性
a {
  text-decoration: none;
  color: inherit;
  display: block;
}

// 顶栏：晶莹半透明白底 + 细腻阴影
.topBar {
  width: 100%;
  height: @topbar-height;
  border-bottom: 1px solid @topbar-border;
  box-sizing: border-box;
  padding: 0 28px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
  display: flex;
  align-items: center;
  justify-content: space-between;

  &_left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .collapse-btn {
    background: #f1f5f9 !important;
    border: 1px solid #e2e8f0 !important;
    color: #475569 !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: #e2e8f0 !important;
      color: @admin-primary !important;
      transform: rotate(90deg); // 微交互：展开收起轻微旋转
    }
  }

  .admin-brand {
    display: flex;
    align-items: center;
    gap: 10px;

    .system-title {
      font-size: 15px;
      font-weight: 700;
      color: #0f172a;
      letter-spacing: 0.3px;
    }

    .admin-badge {
      font-size: 11px;
      font-weight: 700;
      color: #6366f1;
      background: #eef2ff;
      border: 1px solid #e0e7ff;
      padding: 2px 8px;
      border-radius: 6px;
      letter-spacing: 0.5px;
    }
  }
}

// 主体框架
.panel {
  display: flex;
  width: 100%;
  height: calc(100vh - @topbar-height);
  margin-top: @topbar-height;
  overflow: hidden;
  background-color: @bg-page;

  // 侧边栏：采用深绀蓝微渐变
  &_left {
    height: 100%;
    background: linear-gradient(180deg, #151d2f 0%, #0e1320 100%);
    border-right: 1px solid @border-subtle;
    box-shadow: 2px 0 16px rgba(10, 15, 26, 0.12);
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 10;
  }

  &_right {
    flex: 1;
    height: 100%;
    overflow: hidden;

    :deep(.el-scrollbar__wrap) {
      overflow-x: hidden;
    }

    .rv {
      padding: 28px 32px;
      box-sizing: border-box;
      min-height: 100%;
    }
  }
}

// 侧边栏菜单样式
.el-menu {
  height: 100%;
  border-right: none !important;
  background: transparent !important;
  padding: 12px 0;

  &:not(.el-menu--collapse) {
    width: 220px;
  }

  .el-menu-item {
    height: 44px;
    line-height: 44px;
    margin: 4px 12px;
    border-radius: 8px;
    color: @admin-text;
    font-size: 13.5px;
    font-weight: 500;
    transition: all 0.2s ease;
    border: 1px solid transparent;

    .el-icon {
      font-size: 17px;
      margin-right: 12px;
      color: #64748b;
      transition: color 0.2s, transform 0.2s;
    }

    &:hover {
      background-color: @admin-navy-surface !important;
      color: #f1f5f9 !important;

      .el-icon {
        color: #818cf8;
        transform: scale(1.1);
      }
    }

    // 选中态：无尖锐边框，柔和半透明胶囊底色 + 图标聚光
    &.is-active {
      background-color: @admin-active-bg !important;
      border-color: rgba(99, 102, 241, 0.3);
      color: @admin-text-active !important;
      font-weight: 600;

      .el-icon {
        color: #818cf8;
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .topBar {
    padding: 0 16px;
  }
}
</style>
